import R from 'ramda';
import { defaultInterval } from 'ha/modules/ActivationModal/constants';

const getInterval = R.pathOr(defaultInterval, ['activationModal', 'interval']);

export default getInterval;
